import { render, staticRenderFns } from "./CardCompanyCollaborator.vue?vue&type=template&id=169a67ee&scoped=true"
import script from "./CardCompanyCollaborator.vue?vue&type=script&lang=js"
export * from "./CardCompanyCollaborator.vue?vue&type=script&lang=js"
import style0 from "./CardCompanyCollaborator.vue?vue&type=style&index=0&id=169a67ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "169a67ee",
  null
  
)

export default component.exports